import { render, staticRenderFns } from "./Doc.vue?vue&type=template&id=aae31c1a&scoped=true&lang=pug"
var script = {}
import style0 from "./Doc.vue?vue&type=style&index=0&id=aae31c1a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aae31c1a",
  null
  
)

export default component.exports